import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PersistState, persistState } from '@datorama/akita';
import { SplashScreenComponent } from '@libs/common/components';
import { ContentPageModule, provideCep } from '@libs/features/cep';
import { CmsComponent } from '@libs/cms/components';
import { CMS_COMPONENT_TYPE } from '@libs/cms/models';
import { LoginDebuggerComponent, ShellComponent } from '@libs/templates/cep';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { cepBaseRoutes } from './cep-base-routes';

const storage: PersistState = persistState({});

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

@NgModule({
  declarations: [AppComponent],
  imports: [
    RouterModule.forRoot(cepBaseRoutes, {
      initialNavigation: 'enabledNonBlocking',
      scrollPositionRestoration: 'enabled',
      bindToComponentInputs: true,
    }),
    LoginDebuggerComponent,
    ShellComponent,
    ContentPageModule,
    SplashScreenComponent,
  ],
  providers: [
    provideCep(environment.production),
    {
      provide: CMS_COMPONENT_TYPE,
      useValue: CmsComponent,
    },
    {
      provide: 'persistStorage',
      useValue: storage,
    },
  ],
})
export class AppModule {
}
